<template>
  <PageHeader :showBreadcrumb="true" />
  <h2>
    "Licensing Updates & Other Required Reporting"
  </h2>
  <div class="d-flex justify-content-center align-items-center container" style="flex-direction: column">
    <div class="flex-row">
      <P style="margin-right: 5rem;margin-left: 5rem">
        Under Minnesota Statue §62D.08 Subd. 1, every health maintenance organization (HMO)
        and county-based purchaser (CBP) needs to report modifications of several operations
        documents that were submitted as part of the initial HMO or CBP application. In addition,
        HMOs are required to report on cybersecurity events and provide collaboration plans
        or collaboration plan updates every two years. All this information can be submitted
        via this portal module.
        <br/>
        For licensing updates, MDH will respond within 60 days regarding your submission.
        <br/>
        For more information on licensing updates and other required reporting, please visit our website,<br/>
        <a href="https://www.health.state.mn.us/facilities/insurance/managedcare/annualreporting.html"
           target="_blank">Health Plan Reporting Requirements(www.health.mn.us)</a>
      </P>
    </div>
    <div class="flex-row">
      <h3>Please note:</h3>
      <ul>
        <li>&#8226; You may upload a cover letter rather than providing an explanation with your submission.
          Multiple documents may be uploaded as part of a submission.</li>
        <li>&#8226; If you have made changes to a licensing document, please upload both
          a redline copy that clearly shows where changes were made, and a clean copy.
          MDH may contact you for more information during the review period.</li>
        <li>&#8226; Unless otherwise noted, there is a $125 filing fee for each licensing update;
          this will be collected as part of MDH’s quarterly invoicing.
          SERFF change requests are still submitted via email.</li>
        <li>&#8226;Changes to Service Area are submitted through the Network Adequacy section of
          the MCS Portal – please click “Home” in the upper left corner of
          this page to get to that section.
        </li>
      </ul>
    </div>
    <div class="flex-row justify-content-center align-items-center">
      <form @submit.stop.prevent="onSubmit">
        <!-- Display the user entities -->
        <div class="col-lg-12 col-md-12">
          <FormSelectGroup v-if="userEntityOptions"
                           label="Select Entity"
                           inputId="entity-input"
                           :required="true"
                           state>
            <template #default="">
              <PvSelect id="entity-input"
                        v-model="selectedEntity"
                        :options="userEntityOptions"
                        @change="onChangeEntity"
                        ariaLabel="entity-input-label"
                        placeholder="-- Select Entity --"
                        optionLabel="name"
                        optionValue="id"/>
            </template>
          </FormSelectGroup>
        </div>
        <div class="col-lg-12 col-md-12">
          <FormSelectGroup label="Which licensing document(s) are you updating?"
                           inputId="document-input"
                           :required="true"
                           state>
            <template #default="">
              <MultiSelect
                v-model="selectedUploaders"
                :options="uploadersOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Select Licensing Document(s)"
                :max-selected-labels="1"
                :showClear="false"
                :select-all="false"
                :show-toggle-all="false"
                class="w-auto"
              />
            </template>
          </FormSelectGroup>
        </div>
        <div v-for="option in selectedUploaders" :key="option" class="option-content">
          <div class="col-lg-12 col-md-12" v-if="option === 'Other'">
            <FormSelectGroup label="Other Document Type?"
                             inputId="other-input"
                             state>
              <template #default="">
                <input-text
                  id="customOtherInput"
                  type="text"
                  v-model="otherValue"
                  :required = false
                  placeholder="Input Other Document Type here..."
                />
              </template>
            </FormSelectGroup>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script setup>
  import {useAppStore} from '@/stores/appStore';
  import {ENTITY_TYPES, HMO_CDP_UPDATE_DOCUMENTS, ICONS} from "@/utils/constants.js";
  import {computed, ref} from "vue";
  import {useAuthStore} from "@/stores/authStore.js";
  import FormSelectGroup from "@/components/common/FormSelectGroup.vue";
  import {MultiSelect,InputText} from "primevue";
  import PageHeader from "@/components/common/PageHeader.vue";

  const appStore = useAppStore();
  const userStore = useAuthStore();

  const selectedEntity = ref();
  const selectedUploaders = ref([]);
  const otherValue = ref();
  const otherCheck = "Other";

  const uploadersOptions = computed(() => {
    return Object.entries(HMO_CDP_UPDATE_DOCUMENTS).map(([k, v]) => ({
      code: k,
      label: v,
      value: v
    }));
  });

  const userEntityOptions = computed(() => {
    return appStore.getUserEntitiesByTypes([ENTITY_TYPES.HMO, ENTITY_TYPES.CBP]);
  });
</script>

<style scoped>
.tx-p {
  padding: 1.5rem;
  height: 200px;
}
</style>